import { useMutation, useQueryClient } from '@mint-lib/query-client';
import { MediaPlan } from '@mint-sdk/api-media-plan';

import { LOADING_TOTALS } from '../../consts/flights.js';

type Params = {
  flightIds: string[];
  activityId: string;
};

export const useDeleteFlightsApi = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ flightIds }: Params) =>
      MediaPlan.deleteFlights({ data: { flightIds } }),

    onMutate: async ({ flightIds, activityId }) => {
      const queryKey = MediaPlan.getFlightsListQueryOptions({
        params: { activityId },
      }).queryKey;

      await queryClient.cancelQueries({
        queryKey,
      });

      const previousFlights =
        queryClient.getQueryData<MediaPlan.FlightsList>(queryKey);

      queryClient.setQueryData<MediaPlan.FlightsList>(
        queryKey,
        (oldFlights?: MediaPlan.FlightsList) => {
          if (!oldFlights?.data) {
            return;
          }
          return {
            ...oldFlights,
            data: {
              ...oldFlights.data,
              items: oldFlights.data.items.filter(
                (flight) => !flightIds.includes(flight.id),
              ),
              additional: {
                ...oldFlights.data.additional,
                totals: LOADING_TOTALS,
                customFlightCanBeCreated: true,
                isLastFlightDeletable: false,
              },
            },
          };
        },
      );

      return { previousFlights };
    },

    onError: (_, { activityId }, context) => {
      queryClient.setQueryData<MediaPlan.FlightsList>(
        MediaPlan.getFlightsListQueryOptions({ params: { activityId } })
          .queryKey,
        context?.previousFlights,
      );
    },

    onSettled: (_, __, { activityId }) => {
      queryClient.invalidateQueries(
        MediaPlan.getFlightsListQueryOptions({
          params: { activityId },
        }),
      );
    },
  });
};
